<template>
  <div class="flex flex-col items-center justify-center px-2">
    <div class="slide-show relative">
      <img :src="chatImage" class="chat-image" />
      <div class="slider absolute top-0 left-0 overflow-hidden z-10">
        <div
          class="film flex transition-all z-20"
          :style="`transform: translateX(${current * -100}%)`"
        >
          <img
            v-for="n in 3"
            :key="`chat-image-${n}`"
            :src="chatImage"
            class="mobile-device-image"
          />
        </div>
      </div>
    </div>
    <div v-if="$matchMedia.sm" class="flex">
      <div
        v-for="(item, index) in data"
        :key="`chat-item-${index}`"
        class="chat-card cursor-pointer rounded-md flex flex-col items-center w-30 pb-4 px-3 py-5 mb-8 lg:ml-6"
        :class="{ 'bg-gray-7': index === current }"
        @click="setCurrent(index)"
      >
        <img
          :src="item.avatar"
          class="avatar-image w-12 h-12 rounded-full overflow-hidden"
        />
        <div class="flex flex-col text-left pl-3">
          <TypeBody
            :variant="$options.constants.Typography.Body.TEXT"
            :weight="$options.constants.Typography.Weights.STRONG"
            class="mb-1"
            >{{ item.name }}</TypeBody
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { TypeBody, constants } from '@bambeehr/pollen';
import chatImage from '@/assets/images/splash/employee-chat-image.png';
import { employeeChatData } from '@/modules/InformationPages/Product/mocks/SplashCopy';

export default defineComponent({
  components: { TypeBody },
  constants,
  setup() {
    const data = employeeChatData;
    const current = ref(0);
    const slideBy = computed(() => {
      return current.value * -100;
    });
    const setCurrent = (index) => {
      current.value = index;
    };

    return {
      slideBy,
      current,
      setCurrent,
      data,
    };
  },
  data() {
    return {
      chatImage,
    };
  },
});
</script>
